import { COMPANY_DOCUMENTS_PATH } from "@/modules/documents/pages/company-documents";
import { Navigate } from "react-router-dom";

export function OpenCompanyDocument() {
  const url = new URL(window.location.href);
  const documentId = url.searchParams.get("id");

  url.searchParams.delete("id");
  url.pathname = COMPANY_DOCUMENTS_PATH;

  if (!documentId) {
    return <Navigate to="/" />;
  }

  url.searchParams.set("read", documentId);

  return <Navigate to={url.toString().replace(url.origin, "")} />;
}
